import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const tableOption = function (that) {
  return {
    edit: "修改客服录入信息",
    page: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "98px",
    dialogWidth: "800px",
    viewDialogWidth: "700",
    emptyText: "暂无客服录入信息",
    column: [
      {
        label: "客户名称",
        prop: "custom",
        overHidden: true,
        span: 12,
        align: "center",
      },
      {
        label: "司机姓名",
        prop: "driverName",
        overHidden: true,
        align: "center",
      },
      {
        label: "电话",
        prop: "phone",
        overHidden: true,
        align: "center",
      },
      {
        label: "前车车牌",
        prop: "frontPlate",
        span: 12,
        align: "center",
      },
      {
        label: "柜号",
        prop: "cabinetNumber",
        span: 12,
        align: "center",
      },
      {
        label: "作业类型",
        prop: "operateType",
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "装货";
          } else if (Number(value) === 2) {
            return "卸货";
          } else if (Number(value) === 3) return "过车";
        },
        span: 10,
        align: "center",
      },
      {
        label: "操作类型",
        prop: "passType",
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "倒入";
          } else if (Number(value) === 2) {
            return "倒出";
          }
          return "--";
        },
        align: "center",
      },
      {
        label: "货品名称",
        prop: "waresName",
        align: "center",
      },
      {
        label: "数量",
        prop: "waresCount",
        overHidden: true,
        align: "center",
      },
      {
        label: "重量",
        prop: "waresWeight",
        align: "center",
      },
      {
        label: "状态",
        prop: "appointmentStatusName",
        slot: true,
        overHidden: true,
        align: "center",
      },
      {
        label: "预约达到时间",
        prop: "estimatedArrivalTime",
        overHidden: true,
        align: "center",
      },
    ],
  };
};
export default tableOption;
